<div class="hpanel">
  <div class="panel-body">
    No selected item to display. Try clicking one of the rows in the search
    panel.
  </div>
</div>
